import { forwardRef, type HTMLAttributes, type Ref } from 'react';
import { cn } from '@src/design-system/helpers';

type TableProps = HTMLAttributes<HTMLTableElement> & {
  containerClassName?: string;
  containerStyle?: React.CSSProperties;
  containerRef?: Ref<HTMLDivElement>;
};

const Table = forwardRef<HTMLTableElement, TableProps>(
  (
    { className, containerClassName, containerStyle, containerRef, ...props },
    ref
  ) => (
    <div
      ref={containerRef}
      className={cn('relative w-full overflow-auto', containerClassName)}
      style={containerStyle}
    >
      <table
        ref={ref}
        className={cn('w-full caption-bottom text-sm', className)}
        {...props}
      />
    </div>
  )
);

Table.displayName = 'Table';

export default Table;
